import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';

const PersonnelStatisticsTable = () => {
  const [data, setData] = useState([]);
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/statistics/personnelbyserviceandgrade');
        setData(response.data);
        console.log(response.data);

        // Collect all unique grades
        const allGrades = new Set();
        response.data.forEach((service) => {
          Object.keys(service.gradesCount).forEach((grade) => allGrades.add(grade));
        });
        setGrades(Array.from(allGrades));
        console.log(grades);
      } catch (error) {
        console.error('Erreur de chargement des personnels (voir Statistics.js) :', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container mt-5 pt-4 ">
      <h2> Statistics Personnel par Service et Grade</h2>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Service</th>
            {grades.map((grade) => (
              <th key={grade}>{grade}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((service) => (
            <tr key={service.serviceName}>
              <td>{service.serviceName}</td>
              {grades.map((grade) => (
                <td key={grade}>{service.gradesCount[grade] || 0}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PersonnelStatisticsTable;
